var React = require('react');

function Carrier (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Carrier"),React.createElement("path",{"id":"path836-3","className":"cls-1","d":"M56.39,111.22H71.61l38-36.32V53.1l-38-36.32H56.39l-38,36.32V74.9Z","key":2})]);
}

Carrier.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Carrier;

Carrier.default = Carrier;
